import GenerateSessionsForm from '@activities/components/forms/generate-sessions-form/generate-sessions-form.vue';
import SearchAndOrder from '@core/interfaces/bpc-search-and-order';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Activity } from '@activities/interfaces/activity';

@Component({
  name: 'bpc-generate-session-by-time-slots-modal',
  components: {
    'bpc-generate-sessions-form': GenerateSessionsForm,
  },
})
export default class GenerateSessionsByTimeSlotsModal extends Vue {
  declare $refs: {
    generateSessionsForm: InstanceType<typeof GenerateSessionsForm> & {
      formModel: AnyEntity;
    };
  };
  // PROPS
  @Prop({ type: String, default: 'generate-sessions-by-time-slots-modal' })
  readonly modalId: string;
  @Prop({ type: Boolean, default: false }) readonly loading: boolean;
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop(Object) entity;
  @Prop({ type: Object, default: null }) readonly activity: Activity;
  @Prop({ type: Boolean, default: false }) readonly isBulk: boolean;
  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  readonly selectedItemIds: number[];
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  readonly filterModel;
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  readonly searchAndOrder: SearchAndOrder;

  // DATA
  public validateErrors = {};
  public requestSent: boolean = false;
  public isProcessing: boolean = false;
  public eventsSuccess = [];
  public eventsError = [];
  showModalIndex = null;
  readonly errorMessageText: string = 'global.generic.error_form_action';

  // COMPUTED
  get tenantId(): number {
    return this.$store.getters['tenant/selectedTenantId'];
  }

  // LIFECYCLE
  mounted() {
    this.showModalIndex = Date.now();
    this.initVars();
    if (this.showModal) {
      this.openModal();
    }
  }

  initVars() {
    this.requestSent = false;
    this.isProcessing = false;
    this.eventsSuccess = [];
    this.eventsError = [];
    this.validateErrors = null;
  }

  // METHODS
  closeModal() {
    this.showModalIndex = Date.now();
    this.$emit('close-modal');
    this.initVars();
  }

  openModal() {
    this.$bvModal.show(this.modalId);
  }

  onConfirm(processAll: boolean = false) {
    // Processing states
    this.requestSent = true;
    this.isProcessing = true;
    // TODO: Extract function in a service and recieve it by props (perhaps the form component should be in charge of making the request)
    const basePath = this.$bpcApiRouteHelper.getEntityPath('activity-sessions');
    const sessionCode = this.getSessionCode();

    // Fetch data
    const formModel = this.$refs?.generateSessionsForm?.formModel;

    const payload: AnyEntity = {
      group_ids: formModel.group_ids,
      start_date: formModel.start_date,
      end_date: formModel.end_date,
      add_team_members_as_attendees: formModel.add_team_members_as_attendees,
      session_code: sessionCode,
    };

    // Call to websocket
    this.listenToWebsocketGenerateSessionByTimeSlotsChannel(sessionCode);

    // If bulk we need more data in the payload.
    if (this.isBulk) {
      payload.group_ids = this.selectedItemIds;
      payload.filters = this.filterModel;
      payload.search_and_order = this.searchAndOrder;
      payload.process_all = processAll;
      payload.session_code = sessionCode;
    }

    this.$bpcApi.post(basePath + '/generate-by-time-slots', payload).subscribe(
      res => {
        this.requestSent = true;
      },
      error => {
        this.validateErrors = error?.response.data.errors;
        this.requestSent = false;
        this.isProcessing = false;
        if (error?.response.data.errors) {
          this.$bpcMessage.showErrorMessage({ text: this.errorMessageText });
        }
      },
    );
  }

  getSessionCode() {
    return `generate-sessions-by-time-slots-${this.tenantId}-${this.generateUUIDv4()}`;
  }

  listenToWebsocketGenerateSessionByTimeSlotsChannel(sessionCode) {
    this.isProcessing = true;

    this.$bpcEcho
      .getGenerateSessionsChannel(sessionCode)
      .listen('.BPC\\Activities\\Events\\ActivitySessionsGenerated', data => {
        // If not are  sessions generated dont show succes alert.
        if (data.result.processed.length) {
          this.$bpcMessage.showInfoMessage({
            // FIXME the message is not correct
            text: 'global.accounting.invoices.invoices_marked_as_paid',
          });
        }
        this.isProcessing = false;
        this.$root.$emit('generateSessionsFinished');
        this.$emit('generate-sessions-finished');
        this.$bpcEcho.leaveGenerateSessionsChannel(sessionCode);
      })
      .listen('.BPC\\Activities\\Events\\ActivitySessionsForAGroupGenerated', data => {
        this.eventsSuccess.push(data);
      })
      .listen('.BPC\\Activities\\Events\\ErrorGeneratingSessionsForAGroup', data => {
        this.eventsError.push(data);
      })
      .listen('.BPC\\Activities\\Events\\GlobalErrorGeneratingSessions', data => {
        this.$bpcMessage.showErrorMessage({
          text: data.msg,
        });
        this.isProcessing = false;
        this.requestSent = false;
        this.$bpcEcho.leaveGenerateSessionsChannel(sessionCode);
      });
  }

  onValidationWarning(event) {
    console.log('onValidationWarning', event);
  }

  generateUUIDv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  // WATCHERS

  @Watch('showModal')
  onShowModalChange(val) {
    if (val) {
      this.openModal();
    } else {
      this.$bvModal.hide(this.modalId);
    }
  }
}
